module.exports = __webpack_public_path__ + "img/paytable_icon.9468cb29.svg";